module.exports = __webpack_public_path__ + "img/thrive_logo.3c281751.png";